// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.left-pane {
  flex: 0 0 200px;
}

.font-tiny {
  font-size: 0.75rem;
  padding-right: 5px;
}

.sale-header {
  background-color: rgba(0, 0, 0, 0.1);
  padding: 5px;
  line-height: 33px;
  margin-bottom: 7px;
}
.sale-header h1, .sale-header h3 {
  margin-bottom: 0;
  padding-bottom: 0;
}

.non-runner {
  background-color: var(--errorColour);
  color: #fff;
  margin-bottom: 7px;
  text-align: center;
  font-size: 0.75rem;
  font-weight: bold;
}

.showingLot {
  border-radius: 3px;
  padding: 0 4px;
  font-weight: 800;
  font-size: 1.2rem;
  display: inline-block;
  background-color: var(--primaryColour);
  color: #fff;
}

.lotNum {
  background-color: var(--primaryColour);
  color: #fff;
  display: inline-block;
  padding: 0 3px;
  border-radius: 3px;
}

.attention-box {
  background-color: var(--attentionBoxBackgroundColour);
  padding-bottom: 2px;
  border-radius: 7px;
}

.notCurrentLot {
  width: 100%;
  display: block;
  background-color: #c00;
  padding: 5px 10px;
  border-radius: 5px;
}
.notCurrentLot td {
  color: #fff;
}
.notCurrentLot .make-current-lot {
  font-size: 0.75rem;
  font-weight: 600;
  cursor: pointer;
}

.bidHistory {
  font-size: 0.75rem;
  border: 1px solid #ccc;
  padding: 5px;
  font-weight: 400;
  max-height: 120px;
  height: 120px;
  overflow-y: scroll;
  border-radius: 7px;
}
.bidHistory .bidLine {
  border-bottom: 1px solid #ddd;
  overflow-x: hidden;
  text-wrap: none;
  white-space: nowrap;
}
.bidHistory .bidLine .bidAmt {
  display: inline-block;
  width: 70px;
  text-align: right;
  padding-right: 5px;
}

.preview-line1 {
  font-weight: 500;
  font-size: 1.55rem;
  line-height: 1.55rem;
  letter-spacing: -1px;
}

.preview-line2 {
  font-weight: 500;
}

.preview-line3 {
  font-weight: 500;
}

.starting-price {
  font-size: 40px;
  font-weight: 700;
  text-align: center;
}

.update-starting-price {
  width: 180px;
  text-align: center;
  display: inline-block;
}

.starting-price-label {
  margin-top: 15px;
  font-size: 20px;
  font-weight: 400;
  text-align: center;
}

.current-price {
  font-size: 60px;
  font-weight: 700;
  text-align: center;
}

.next-bid {
  font-weight: 300;
  font-size: 0.875rem;
}

.current-bid-title {
  font-size: 1.75rem;
  font-weight: 400;
}

.right-pane {
  flex: 0 0 320px;
}

.preview-pane {
  height: 480px;
  overflow-y: auto;
  margin-bottom: 20px;
}
.preview-pane .lot-container {
  width: 95%;
  background-color: #ddd;
  margin-bottom: 10px;
  border-radius: 5px;
  padding-bottom: 4px;
}
.preview-pane .make-model {
  padding: 2px 5px;
  font-size: 0.7rem;
  height: 34px;
  overflow-y: hidden;
}
.preview-pane .make-model .lotNum {
  font-weight: 700;
}
.preview-pane .make-model .lotVrm {
  font-weight: 600;
}

.advertId {
  font-size: 0.75rem;
}

.bidderCompany {
  font-weight: 600;
  font-size: 0.75rem;
}

.bidderContact {
  font-size: 0.75rem;
}

.bidderTown {
  font-weight: 500;
}

.bidderOnlineBox {
  border-bottom: 1px solid #ccc;
}

.ggg-button {
  color: #fff;
  font-weight: 500;
}

.ggg-0 {
  background-color: #28a745;
}

.ggg-1 {
  background-color: #a7a745;
}

.ggg-2 {
  background-color: #a74545;
}

.ggg-3 {
  background-color: #555555;
}

.reserve-price {
  font-weight: 500;
  padding: 2px 5px;
  border-radius: 3px;
}

.reserve-met-false {
  background-color: var(--errorColour);
  color: #fff;
}

.reserve-met-true {
  background-color: var(--successColour);
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/admin/sale/sale-auctioneer/sale-auctioneer.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;;AAEA;EACE,kBAAA;EACA,kBAAA;AACF;;AAEA;EACE,oCAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AACF;AACE;EACE,gBAAA;EACA,iBAAA;AACJ;;AAGA;EAEE,oCAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;AADF;;AAMA;EACE,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;EACA,sCAAA;EACA,WAAA;AAHF;;AAMA;EACE,sCAAA;EACA,WAAA;EACA,qBAAA;EACA,cAAA;EACA,kBAAA;AAHF;;AAMA;EAEE,qDAAA;EACA,mBAAA;EACA,kBAAA;AAJF;;AAQA;EAEE,WAAA;EACA,cAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AANF;AAQE;EACE,WAAA;AANJ;AASE;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;AAPJ;;AAWA;EAEE,kBAAA;EACA,sBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AATF;AAWE;EAEE,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;AAVJ;AAYI;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;AAVN;;AAgBA;EAEE,gBAAA;EACA,kBAAA;EACA,oBAAA;EACA,oBAAA;AAdF;;AAkBA;EAEE,gBAAA;AAhBF;;AAoBA;EACE,gBAAA;AAjBF;;AAoBA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAjBF;;AAoBA;EACE,YAAA;EACA,kBAAA;EACA,qBAAA;AAjBF;;AAoBA;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;AAjBF;;AAoBA;EAEE,eAAA;EACA,gBAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,gBAAA;EACA,mBAAA;AAlBF;;AAsBA;EACE,kBAAA;EACA,gBAAA;AAnBF;;AAsBA;EACE,eAAA;AAnBF;;AAsBA;EACE,aAAA;EACA,gBAAA;EACA,mBAAA;AAnBF;AAqBE;EACE,UAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAnBJ;AAsBE;EACE,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;AApBJ;AAsBI;EACE,gBAAA;AApBN;AAuBI;EACE,gBAAA;AArBN;;AA0BA;EACE,kBAAA;AAvBF;;AA0BA;EACE,gBAAA;EACA,kBAAA;AAvBF;;AA0BA;EACE,kBAAA;AAvBF;;AA0BA;EACE,gBAAA;AAvBF;;AA0BA;EACE,6BAAA;AAvBF;;AA0BA;EACE,WAAA;EACA,gBAAA;AAvBF;;AA0BA;EACE,yBAAA;AAvBF;;AA0BA;EACE,yBAAA;AAvBF;;AA0BA;EACE,yBAAA;AAvBF;;AA0BA;EACE,yBAAA;AAvBF;;AA0BA;EACE,gBAAA;EACA,gBAAA;EACA,kBAAA;AAvBF;;AA0BA;EACE,oCAAA;EACA,WAAA;AAvBF;;AA0BA;EACE,sCAAA;EACA,WAAA;AAvBF","sourcesContent":[".left-pane {\n  flex: 0 0 200px;\n}\n\n.font-tiny {\n  font-size: 0.75rem;\n  padding-right: 5px;\n}\n\n.sale-header {\n  background-color: rgba(0, 0, 0, 0.1);\n  padding: 5px;\n  line-height: 33px;\n  margin-bottom: 7px;\n\n  h1, h3 {\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n}\n\n.non-runner {\n\n  background-color: var(--errorColour);\n  color: #fff;\n  margin-bottom: 7px;\n  text-align: center;\n  font-size: 0.75rem;\n  font-weight: bold;\n\n\n}\n\n.showingLot {\n  border-radius: 3px;\n  padding: 0 4px;\n  font-weight: 800;\n  font-size: 1.2rem;\n  display: inline-block;\n  background-color: var(--primaryColour);\n  color: #fff;\n}\n\n.lotNum {\n  background-color: var(--primaryColour);\n  color: #fff;\n  display: inline-block;\n  padding: 0 3px;\n  border-radius: 3px;\n}\n\n.attention-box {\n\n  background-color: var(--attentionBoxBackgroundColour);\n  padding-bottom: 2px;\n  border-radius: 7px;\n\n}\n\n.notCurrentLot {\n\n  width: 100%;\n  display: block;\n  background-color: #c00;\n  padding: 5px 10px;\n  border-radius: 5px;\n\n  td {\n    color: #fff;\n  }\n\n  .make-current-lot {\n    font-size: 0.75rem;\n    font-weight: 600;\n    cursor: pointer;\n  }\n}\n\n.bidHistory {\n\n  font-size: 0.75rem;\n  border: 1px solid #ccc;\n  padding: 5px;\n  font-weight: 400;\n  max-height: 120px;\n  height: 120px;\n  overflow-y: scroll;\n  border-radius: 7px;\n\n  .bidLine {\n\n    border-bottom: 1px solid #ddd;\n    overflow-x: hidden;\n    text-wrap: none;\n    white-space: nowrap;\n\n    .bidAmt {\n      display: inline-block;\n      width: 70px;\n      text-align: right;\n      padding-right: 5px;\n    }\n  }\n\n}\n\n.preview-line1 {\n\n  font-weight: 500;\n  font-size: 1.55rem;\n  line-height: 1.55rem;\n  letter-spacing: -1px;\n\n}\n\n.preview-line2 {\n\n  font-weight: 500;\n\n}\n\n.preview-line3 {\n  font-weight: 500;\n}\n\n.starting-price {\n  font-size: 40px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.update-starting-price {\n  width: 180px;\n  text-align: center;\n  display: inline-block;\n}\n\n.starting-price-label {\n  margin-top: 15px;\n  font-size: 20px;\n  font-weight: 400;\n  text-align: center;\n}\n\n.current-price {\n\n  font-size: 60px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.next-bid {\n  font-weight: 300;\n  font-size: 0.875rem;\n}\n\n\n.current-bid-title {\n  font-size: 1.75rem;\n  font-weight: 400;\n}\n\n.right-pane {\n  flex: 0 0 320px;\n}\n\n.preview-pane {\n  height: 480px;\n  overflow-y: auto;\n  margin-bottom: 20px;\n\n  .lot-container {\n    width: 95%;\n    background-color: #ddd;\n    margin-bottom: 10px;\n    border-radius: 5px;\n    padding-bottom: 4px;\n  }\n\n  .make-model {\n    padding: 2px 5px;\n    font-size: 0.7rem;\n    height: 34px;\n    overflow-y: hidden;\n\n    .lotNum {\n      font-weight: 700;\n    }\n\n    .lotVrm {\n      font-weight: 600;\n    }\n  }\n}\n\n.advertId {\n  font-size: 0.75rem;\n}\n\n.bidderCompany {\n  font-weight: 600;\n  font-size: 0.75rem;\n}\n\n.bidderContact {\n  font-size: 0.75rem;\n}\n\n.bidderTown {\n  font-weight: 500;\n}\n\n.bidderOnlineBox {\n  border-bottom: 1px solid #ccc;\n}\n\n.ggg-button {\n  color: #fff;\n  font-weight: 500;\n}\n\n.ggg-0 {\n  background-color: #28a745;\n}\n\n.ggg-1 {\n  background-color: #a7a745\n}\n\n.ggg-2 {\n  background-color: #a74545;\n}\n\n.ggg-3 {\n  background-color: #555555;\n}\n\n.reserve-price {\n  font-weight: 500;\n  padding: 2px 5px;\n  border-radius: 3px;\n}\n\n.reserve-met-false {\n  background-color: var(--errorColour);\n  color: #fff;\n}\n\n.reserve-met-true {\n  background-color: var(--successColour);\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
